module.exports = __webpack_public_path__ + "img/base_d_dark.86a81bc9.svg";